import { render, staticRenderFns } from "./DynamicSwitch.vue?vue&type=template&id=2163d150&scoped=true"
import script from "./DynamicSwitch.vue?vue&type=script&lang=js"
export * from "./DynamicSwitch.vue?vue&type=script&lang=js"
import style0 from "./DynamicSwitch.vue?vue&type=style&index=0&id=2163d150&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2163d150",
  null
  
)

/* custom blocks */
import block0 from "./DynamicSwitch.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports